import { TariffType } from '../model';

export const getTariffType = (isDCPerKilowatt: boolean): TariffType => {
  return isDCPerKilowatt ? 0 : 1;
};
